import {
    SimplePresentation,
    SimplePresentationRunnerController
} from "../../../core/winpresentation/SimplePresentationRunner";
import {TheCage} from "../../TheCage";
import {TheCageGameMode} from "../../server/TheCageGameMode";
import {gsap} from "gsap";
import {TheCageSound} from "../../sound/TheCageSound";
import {RestoreUtils} from "../../utils/RestoreUtils";

/**
 * Created by jonas on 2022-09-02.
 */

export class FreesSpinLevelUp implements SimplePresentation {

    name:string = "FreesSpinLevelUp";

    constructor() {

    }

    public shouldRun():boolean {
        // long names :upside_down_face:
        return TheCage.model.data.nBNcollectedInFSAfter[TheCage.model.data.fsLevel]
            >= TheCage.model.initData.BN_LEVEL_FS[TheCage.model.data.fsLevel] &&
            TheCage.model.data.nBNcollectedInFSBefore[TheCage.model.data.fsLevel] !=
            TheCage.model.data.nBNcollectedInFSAfter[TheCage.model.data.fsLevel];
    }

    public start(controller:SimplePresentationRunnerController):void {
        const tl = gsap.timeline();
        const fsLevel = TheCage.model.data.fsLevel;

        TheCage.autoPlayPlugin.turnOffAutoplayOnBonus();


        tl.add(TheCage.transitionScreen.showLevelUp(fsLevel));
        tl.add(TheCage.freeSpinReelView.playerCounter.swapCounter(fsLevel + 1), '<1.5');
        tl.add(TheCage.freeSpinReelView.opponentCounter.swapCounter(fsLevel + 1), '<');
        tl.add(TheCage.keypadPlugin.hide(0.1),0);

        tl.add([
            ()=>{
                if (TheCage.model.data.fsLevel == 3 || TheCage.model.data.fsLevelEnterWith == 4) {
                    TheCage.soundPlayer.switchMusic("FS_INTRO_LVL5");
                } else {
                    TheCage.soundPlayer.switchMusic("FS_INTRO");
                }
            },
            () => {
                TheCage.soundPlayer.playSound(TheCageSound.FS_INTRO_START);
            }
        ], 1.427);

        tl.add(() => {TheCage.soundPlayer.playSound(TheCageSound.FS_FIGHTER_NAME_APPEAR)});
        tl.add(TheCage.transitionScreen.showFighterName(fsLevel + 1));
        tl.add(TheCage.freeSpinReelView.opponentCounter.fillUp(), '<0.5');
        tl.add(() => {TheCage.soundPlayer.playSound(TheCageSound.FS_SPINS_TEXT_APPEAR)}, '<0.67');
        tl.add(TheCage.transitionScreen.showFreespinsRewarded(fsLevel + 1), '<');
        tl.add(TheCage.transitionScreen.enableButton(() => this.onButtonClick(controller)), '<0.1');
        tl.add(TheCage.freeSpinReelView.playerCounter.fillUp(), '<0.2');
        tl.add(TheCage.freeSpinReelView.features.levelUp(), '<0.55');
    }

    private onButtonClick(controller:SimplePresentationRunnerController) {
        const tl:gsap.core.Timeline = gsap.timeline();

        TheCage.freeSpinReelView.opponent.init(TheCage.model.data.fsLevel + 1);
        tl.add(() => {
            TheCage.freeSpinReelView.avalancheMatrixModel.init(RestoreUtils.EMPTY_FREESPINS_MATRIX,
                                                               TheCage.freeSpinReelView.startPositions);
            TheCage.soundPlayer.switchMusic(`FS_LEVEL_${TheCage.model.data.fsLevel + 2}`);
            TheCage.keypadPlugin.setZeroBetSpinCounter(TheCage.model.data.freespinsLeft);
            TheCage.keypadPlugin.show(0.1);
        });

        tl.add(TheCage.transitionScreen.hideLevelUp());
        //tl.add(() => {TheCage.freeSpinReelView.opponent.reveal()});
        tl.add(()=>{
            TheCage.soundPlayer.playSound(TheCageSound.FS_RE_TRIGGER)
        });
        tl.add(() => {}, '>0.3');

        tl.add(() => controller.finish());

    }
}
